<div class="content-with-stepper-and-title d-block">

    <div *ngIf="statusValidation" class="alert">
        <voxel-icon>
            aviso_outline
        </voxel-icon>
        <span>
            {{ copyService.copies.prioritizeProducts.errorSelectProduct}}
        </span>
    </div>
    
    <h1 class="title-prioritze"> {{ copyService.copies.prioritizeProducts.request_products_title}} </h1>
    <br>
    <br>
    <h3 class="subtitle mb-3">  {{ copyService.copies.prioritizeProducts.request_products_sub_title}} </h3>

    <form [formGroup]="formGroup" >
        <div class="row fieldProduct" *ngFor="let row of select_products; index as i">
            <voxel-form-field [label]="copyService.copies.prioritizeProducts.labels[i]"
                              [msgErr]="error"
                              class="mb-3 col-12 col-pr-6 col-sm-4 col-md-4 col-xl-4 col-lg-4">
                <vcl-autocomplete [placeholder]="copyService.copies.prioritizeProducts.labels[i]"
                                  [notFoundTitle]="copyService.copies.prioritizeProducts.error"
                                  [notFoundMessage]="copyService.copies.prioritizeProducts.error_description"
                                  [formControlName]="i">
                    <vcl-option [id]="'doc_type_' + doc_type.id "
                                *ngFor="let doc_type of select_products"
                                [value]="doc_type.flow">
                        {{ doc_type.name }}
                    </vcl-option>
                </vcl-autocomplete>
            </voxel-form-field>
        </div>
    </form>

    <app-controls [hasPrevious]="true"
                  [nextLabel]="copyService.copies.form_second_info.button"
                  [nextDisabled]="!formGroup.valid || statusValidation"
                  (next)="next()"></app-controls>
</div>
